import { useState } from "react";
import { LocateFixed, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useLocate } from "@/lib/geo";

export const LocationBanner = () => {
  const { t } = useApp();
  const { locate, busy } = useLocate();
  const [show, setShow] = useState(() => !!navigator.geolocation && !localStorage.getItem("dm_loc_asked") && !localStorage.getItem("dm_hub"));
  if (!show) return null;
  const close = () => { localStorage.setItem("dm_loc_asked", "1"); setShow(false); };
  return (
    <div data-testid="location-banner" className="rise rounded-2xl bg-[#FFFDF9] border-2 border-[#1E4D3B]/20 card-shadow p-4 flex items-start gap-3">
      <span className="w-12 h-12 rounded-full bg-[#1E4D3B] text-[#F59E0B] flex items-center justify-center shrink-0"><LocateFixed className="w-6 h-6" /></span>
      <div className="flex-1 min-w-0">
        <div className="font-extrabold leading-snug">{t("loc_title")}</div>
        <div className="text-sm text-[#6B5E55]">{t("loc_body")}</div>
        <div className="flex flex-wrap gap-2 mt-2">
          <button data-testid="location-allow" disabled={busy} onClick={async () => { await locate(); setShow(false); }} className="press min-h-[44px] px-4 rounded-full bg-[#1E4D3B] text-white text-sm font-bold">{t("loc_use")}</button>
          <button data-testid="location-not-now" onClick={close} className="press min-h-[44px] px-4 rounded-full bg-[#F3EDE4] text-sm font-bold">{t("loc_not_now")}</button>
        </div>
      </div>
      <button data-testid="location-dismiss" aria-label={t("dismiss")} onClick={close} className="self-start w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F3EDE4]"><X className="w-4 h-4" /></button>
    </div>
  );
};
